// ════════════════════════════════════════════════════════════════
// Ссылки для продвижения (22.09.2026): одна ссылка — одна функция приложения.
//
//   https://t.me/kokorineatbot?startapp=<функция>          например startapp=photo
//   https://t.me/kokorineatbot?startapp=<функция>_<метка>  например startapp=photo_kafe
//   в вебе: https://slavahealth.ru/?start=<функция>_<метка>
//
// Метка — кодовое слово латиницей: по ней видно, какой пост привёл человека
// (пишется в profiles.acquisition у новичков). Разрешены латиница, цифры и «-»:
// Telegram принимает в startapp только [A-Za-z0-9_-], до 64 символов.
//
// ref_… и gift_… — отдельные механики (рефералка и подарки), здесь не трогаем.
// Список ссылок для Славы — docs/promo-links.md.
// ════════════════════════════════════════════════════════════════

export type LaunchFeature = 'app' | 'test' | 'chat' | 'listen' | 'photo' | 'text' | 'habits' | 'path' | 'relax' | 'stats';

export const FEATURE_ROUTE: Record<LaunchFeature, string> = {
  // «Просто приложение» (03.10.2026): ссылка без конкретной функции, только
  // чтобы знать площадку. Нужна, потому что разбор требует имя функции первым:
  // startapp=threads без неё игнорируется целиком и метка не записывается.
  app: '/',
  test: '/test',
  chat: '/chat',
  listen: '/chat',          // чат сразу в режиме «просто выслушай»
  photo: '/add?mode=photo',
  text: '/add?mode=text',
  habits: '/',              // карточка «Привычки с Дофи» на главной
  path: '/path',
  relax: '/chat?tab=relax',
  stats: '/stats',
};

export type Launch = { raw: string; feature: LaunchFeature; label: string | null };

function rawParam(): string | null {
  try {
    const sp = (window as any).Telegram?.WebApp?.initDataUnsafe?.start_param;
    if (typeof sp === 'string' && sp) return sp;
    return new URLSearchParams(window.location.search).get('start');
  } catch {
    return null;
  }
}

export function getLaunch(): Launch | null {
  const raw = rawParam();
  if (!raw) return null;
  const [head, ...rest] = raw.split('_');
  if (!(head in FEATURE_ROUTE)) return null;
  return { raw: raw.slice(0, 64), feature: head as LaunchFeature, label: rest.join('_') || null };
}
